'use client';
import {Spacer} from 'node_modules/@repo/ui/src/spacer';
import Markdown from 'react-markdown';

interface InterviewExperiencesSummaryProps {
  editorial?: string;
  editorialTitle?: string;
  totalCount: number;
}

function candidateReportCount(count: number): string {
  if (count === 1) return '1 candidate report';
  return `${count} candidate reports`;
}

export default function InterviewExperiencesSummary({
  editorial,
  totalCount,
  editorialTitle,
}: InterviewExperiencesSummaryProps) {
  const finalEditorialTitle = editorialTitle || 'Editorial';

  if (!editorial) return null;
  return (
    <>
      <div
        className='rounded-xl p-5'
        style={{
          backgroundColor: 'rgba(0,0,0,0.03)',
          border: '1px solid rgba(0,0,0,0.08)',
        }}>
        <h2 className='text-xl font-bold text-iq-black mt-1 mb-3'>{finalEditorialTitle}</h2>
        <div className='leading-relaxed prose prose-sm max-w-none'>
          <Markdown components={{p: ({children}) => <p className='mb-2 last:mb-0'>{children}</p>}}>
            {editorial}
          </Markdown>
        </div>
        <Spacer />
        <p className='leading-relaxed caption-bottom text-iq-grey-medium  text-xs'>
          Synthesized from {candidateReportCount(totalCount)} by our editorial team.
        </p>
      </div>
      <Spacer size='xl' />
    </>
  );
}
